import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { AIDataset } from 'elements-sdk'
import { AIService } from 'ai/services/ai.service'
import { APIService } from 'api/module'
import { PickerService } from 'common/util.pickers/services/picker.service'
import { MediaPermissionsService } from 'media/services/mediaPermissions.service'
import { PanelService } from 'panel/services/panel.service'
import { MediaOperationsService } from '../services/mediaOperations.service'
import { BaseOperation } from './base'

@Injectable({ providedIn: 'root' })
class UploadForAIOp extends BaseOperation {
  icon = 'far fa-lightbulb-on'
  showInContextMenu = true
  showInSelectionOverflowMenu = true
  supportsMultiple = true
  supportsDirs = true
  supportsBundles = true
  weight = 90

  constructor (
    private translate: TranslateService,
    private panel: PanelService,
    private ai: AIService,
    private picker: PickerService,
    private api: APIService,
    private mediaPermissions: MediaPermissionsService,
  ) {
    super()
    this.label = translate.instant('Run AI')
  }

  isVisibleForDir (dir, options) {
    if (!this.mediaPermissions.getPermissionForFile(dir)?.allowSharing) {
      return false
    }
    return !this.panel.active && options.root?.aiConnection
  }

  isVisibleForBundle (bundle, options) {
    if (!this.mediaPermissions.getPermissionForBundle(bundle)?.allowWriteDb) {
      return false
    }
    return !this.panel.active && options.root?.aiConnection
  }

  isEnabledForBundle (bundle, _options) {
    return ['video', 'image'].includes(bundle.asset?.type) && bundle.asset?.proxiesGenerated
  }

  async run ({ dirs, bundles }, options) {
    if (options.root?.aiConnection) {
      const sets: AIDataset[]|null = await this.picker.pickObjects({
        items: this.api.ai.getAllAIDatasets({ connection: options.root.aiConnection }).then(d => d.map(ds => ({
          name: ds.name,
          group: this.translate.instant('Datasets'),
          iconClass: 'far fa-images',
          object: ds as AIDataset,
          enabled: !!ds.lastFinishedModel,
          description: ds.lastFinishedModel ? '' : this.translate.instant('No models available'),
        }))),
        title: this.translate.instant('Select datasets'),
        multiple: true,
      }).catch(() => null)

      if (sets && sets.length > 0) {
        this.ai.createMetadata(
          bundles.filter(x => x.asset).map(x => x.asset.id),
          dirs.map(x => x.id),
          sets,
          options.root.aiProxyProfile,
        )
      }
    }
  }
}

MediaOperationsService.register(UploadForAIOp)
